module.exports = __webpack_public_path__ + "site/img/30.83572d64.jpg";